import { render } from "./MoreSelect.vue?vue&type=template&id=b129d2f2&scoped=true"
import script from "./MoreSelect.vue?vue&type=script&lang=js"
export * from "./MoreSelect.vue?vue&type=script&lang=js"

import "./MoreSelect.vue?vue&type=style&index=0&id=b129d2f2&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/dayungs_pos_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b129d2f2"]])

export default __exports__